import type { EUserRole } from '@~/reducers/auth';
import { getCookie, setCookie } from '@~/utils';

export const getUserIdFromCookie = () =>
  // idl - userId cookie set for leap.cuemath.com
  getCookie('idl');

export const getStudentServiceIdFromCookie = () =>
  // idl - userId cookie set for leap.cuemath.com
  getCookie('ssidl');

export const getActiveUserTypeFromCookie = () =>
  // aut - active user type cookie set for leap.cuemath.com
  getCookie('aut') as EUserRole | undefined;

export const getLoggedInAsFromCookie = () =>
  // lau - logged in as user cookie set for leap.cuemath.com
  getCookie('lau') as EUserRole | undefined;

export const setActiveUserTypeInCookie = (userType: EUserRole) => {
  setCookie('aut', userType);
};

export const setLoggedInAsInCookie = (userRole: EUserRole) => {
  setCookie('lau', userRole);
};

export const validatePassword = (pwd: string) => {
  if (!pwd.trim()) return 'Password is required';

  return pwd.length >= 6 ? null : 'Password must be at least 6 characters';
};
